import React from 'react';
import { ParticipantReaction } from '../../types';
import { ReactionEmoji, ReactionIconWrapper } from './view';

interface ReactionIconProps {
    reaction: ParticipantReaction;
}

export const ReactionIcon: React.FC<ReactionIconProps> = ({ reaction }) => {
    return (
        <ReactionIconWrapper>
            <ReactionEmoji>{reaction.type}</ReactionEmoji>
        </ReactionIconWrapper>
    );
};
